import Vue from 'vue'
import VueRouter from 'vue-router'
import LightBootstrap from './light-bootstrap-main'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import config from '../config/settings'
import Toaster from 'v-toaster'
import VueSlider from 'vue-slider-component'
import { SliderPlugin } from "@syncfusion/ej2-vue-inputs";
import ToggleButton from "vue-js-toggle-button";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);
// import JsonExcel from 'vue-json-excel'
import "vue-select/dist/vue-select.css";
import 'v-toaster/dist/v-toaster.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-slider-component/theme/default.css'
import 'gridstack/dist/gridstack.css';
import Clipboard from 'v-clipboard'

Vue.use(Clipboard)


Amplify.configure(config.cred);
// Plugins
import App from './App.vue'
Vue.use(Toaster, { timeout: 3000 })

// router setup
import { routes } from './routes/routes'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
//To use vue-amplify
Vue.use(AmplifyPlugin, AmplifyModules)
//slider
Vue.component('VueSlider', VueSlider)
Vue.use(SliderPlugin);
//Download Excel
// Vue.component('downloadExcel', JsonExcel)
//Toggle Button
Vue.use(ToggleButton)

// modify Chart-js legend construct to allow for fixed-width legends
import Chart from 'chart.js'
Chart.Legend.prototype.afterFit = function () {
  var opts = this.options
  if (typeof this.options.width === 'number') {
    this.minSize.width = opts.width
    this.width = opts.width
  }
  if (typeof this.options.height === 'number') {
    this.minSize.height = opts.height
    this.height = opts.height
  }
}

// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)

// configure router
const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

// configure api request to use the api base-url
Vue.use({
  install: function (Vue, options) {
    Vue.prototype.$api = require('./axios_api')
  }
})

// create a rule to redirect to login if we are attempting to access any other page w/o a jwt
router.beforeEach((to, from, next) => {
  //if (to.query.token) store.commit('user/token', { token: to.query.token })
  if (to.query.user) return next()
  else if (to.path.includes('signup')) return next()
  else if (to.path.includes('forgot')) return next()
  else if (to.path.includes('invite')) return next()
  else if (to.path.includes('investors')) return next()
  else if (!to.path.includes('login') && !store.getters['user/hasToken']) {
    // redirect to login
    return next('/login')
  }
  if (to.path.includes('signup')) return next('/signup')
  else
    next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})


export default router

